import React from 'react';
import {
    Input,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Navbar,
    Nav,
    NavLink,
    Row,
    Col,
} from 'reactstrap';
import NavBar from '../NavBar/navBar'
import ReactTable from "react-table";
import { connect } from "react-redux";
import {
    fetchRooms,
    saveRoom,
    deleteRoom,
} from '../../actions';
import Pagination from '../Pagination/pagination'
import { toast, ToastContainer } from 'react-toastify';
import { NavLink as RRNavLink } from 'react-router-dom';
import Tour from '../../Tour';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';

import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-toastify/dist/ReactToastify.css";
import "./addRoom.css";
import radioButton from '../../assets/radioButton.svg';
import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg';
import deleteIcon from '../../assets/delete.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';

let errorDetails = ""
const initialState = {
    id: "",
    roomName: "",
    roomId: "",
    isDeleteModalOpen: false,
    deleteID: "",
    isDisable: false,
    view: true,
}

class AddRooms extends React.Component {
    constructor(props) {
        super(props)
        this.saveData = this.saveData.bind(this)
        this.resetData = this.resetData.bind(this)
        this.validateData = this.validateData.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            ...initialState,
        }
    }

    roomColumns = [
        {
            Header: 'Room Name',
            accessor: 'room_name',
        },
        {
            Header: 'Room ID',
            accessor: 'room_id',
        },
        {
            id: 'delete',
            accessor: str => "delete",
            Cell: (row) => (
                <div className='dropdown-filter'   onClick={(e) => this.handleButtonClick(e, row.original.id, row.original.room_name)}>
                <img src={deleteIcon} alt=''/>
                </div>
            ),
            className:"delete-button-padding",
        }
    ]

    handleButtonClick = (e, id, name) => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteName: name,
            deleteID: id
        }));
    }

    componentDidMount() {
        this.props.fetchRooms()
    }

    deleteRoom = () =>{
        this.props.deleteRoom(this.state.deleteID).then(response => {
            if(response.status === 204){
                if (appInsights) {
                    appInsights.trackEvent({name:'Room Deleted', properties: {id: this.state.deleteID}});
                    appInsights.trackTrace({message: 'Room with ID '+ this.state.deleteID+' is deleted', severityLevel: SeverityLevel.Information});
                }
                toast.success(this.state.deleteName + " Deleted Successfully!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                this.setState(prevState => ({
                    isDeleteModalOpen: false,
                    deleteName: "",
                    deleteID: ""
                }));
                this.props.fetchRooms()
            }
            else {
                if (appInsights) {
                    appInsights.trackTrace({message: 'Room couldn\'t be deleted!', properties: {id: this.state.deleteID}, severityLevel: SeverityLevel.Error});
                }
                toast.error(this.state.deleteName + " couldn't be deleted!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch((error) =>{
            let message = this.state.deleteName + " couldn't be deleted!"
            if (appInsights) {
                appInsights.trackTrace({message: message, properties: {id: this.state.deleteID, error: error}, severityLevel: SeverityLevel.Error});
            }
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }

    toggleDeleteModal = () => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteLocationId: ""
        }));
    }

    handleChange(event) {
        if(event.target.name == ""){
            this.setState({
                ...this.state,
                ['addItem']: event.target.value
            })    
        }
        else{
            this.setState({
                ...this.state,
                [event.target.name]: event.target.value
            })
        }
    };

    saveData = () => {
        if (this.validateData(this.state)) {
            let createData = {
                room_id :this.state.roomId,
                room_name: this.state.roomName,
            }
            this.props.saveRoom(createData).then(response => {
                    if (response.status === 201) {
                        this.resetData()
                        if (appInsights) {
                            appInsights.trackEvent({name:'Room Added', properties:{name: response.data.room_name, id: response.data.room_id}});
                            appInsights.trackTrace({message:'Room Added', properties:{name: response.data.room_name, id: response.data.room_id}, severityLevel: SeverityLevel.Information});
                        }
                        toast.success( "Room is added successfully to the list", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        this.props.fetchRooms()
                    }
                    else {
                        let message = "Rooms couldn't be added!"
                        if (appInsights) {
                            appInsights.trackTrace({message: message, properties:{id: this.state.roomId, name: this.state.roomName}, severityLevel: SeverityLevel.Error});
                        }
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                })
                    .catch((error) => {
                        let message = "Room couldn't be added!"
                        if (appInsights) {
                            appInsights.trackTrace({message: message, properties:{id: this.state.roomId, name: this.state.roomName, error: error}, severityLevel: SeverityLevel.Error});
                        }
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        })
                    })
        } 
        else {
            this.ErrorDetails()
        }
        
    }

    ErrorDetails = () => {
        if (appInsights) {
            appInsights.trackTrace({message: errorDetails, severityLevel: SeverityLevel.Verbose});
        }
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    resetData = () => {
        this.setState({roomId: "", roomName: ""})
    } 

    cancelData = () => {
        this.setState(initialState)
    }

    validateData = (data) => {
        if (data.roomId.trim().length > 0 && data.roomName.trim().length > 0) {
            return true
        }
        else{
            errorDetails = "All *mandatory fields are required to create a Room!"
            return false
        }
    }

    handleError = (err) => {
        console.error(err)
    }

    render() {
        return(
            <div data-tut="reactour__manage" className="manage-page page-layout">
                <NavBar />
                <div className={window.innerWidth>900?"dashboard-overview samples-page": "dashboard-overview-100 samples-page"}>
                <div className="dashboard-content-25 ">
                        <Row className="manage-page-header mt-0" form>
                            <Navbar className="navbar-results" light expand="md">
                                <Nav navbar data-tut="reactour__nav">
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/"><span className="nav-col"><img src={radioButtonhighlighted} className = "nav-icons" alt=''/>Manage Locations</span></NavLink>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/locations"><span className="nav-col"><img src={radioButton} className = "nav-icons" alt=''/>View Locations</span></NavLink>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/notifications/"><span className="nav-col"><img src={radioButton} className = "nav-icons" alt=''/>Manage Notifications</span></NavLink>
                                </Nav>
                            </Navbar>
                        </Row>
                        <div className="sample-input-area">
                            <Row form data-tut="reactour__dropdown">
                                <Col md={4} xl={2} lg ={2}>
                                    <Input className="sample-input-fields" type="select" name="addItem" id="AddItem" value={this.state.addItem} onChange={this.handleChange} size="1">
                                        <option value="AddRoom" className="dashboard-options" default>Add a Room</option>
                                        <option value="AddBuilding" className="dashboard-options" >Add a Building</option>
                                        <option value="AddFloor" className="dashboard-options" >Add a Floor</option>
                                    </Input>
                                </Col>
                                <Col md={4}  xl={2} lg ={2}>
                                    <Input className={this.state.roomName ? "sample-input-fields" : "sample-input-fields default-disabled"} type="text" autoComplete="off" name="roomName" id="roomName" size="10" value={this.state.roomName} onChange={this.handleChange} placeholder="Room Name*" />
                                </Col>
                                <Col md={4} lg ={2} xl={2}>
                                    <Input className={this.state.roomId ? "sample-input-fields" : "sample-input-fields default-disabled"} type="text" autoComplete="off" name="roomId" id="roomId" size="10" value={this.state.roomId} onChange={this.handleChange} placeholder="Room Id*" />
                                </Col>
                                <Col lg={6} xl={6}>
                                    <div  className = "manage-buttons" >
                                        <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={() => this.resetData()} >Clear</Button>
                                        <Button id="applyFloorButton" type="submit" outline color="secondary" onClick={() => this.saveData()} >Add</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="grid-data" data-tut="reactour__tableRoom">
                        <div className="sample-list-header building-heading">Rooms</div>
                        {this.props.rooms && this.props.rooms.length > 0 ?
                                <div className="location-table-height" >
                                    <ReactTable className="Data-Table tables-height"
                                        data={this.props.rooms}
                                        columns={this.roomColumns}
                                        defaultPageSize={10}
                                        showPagination={true}
                                        PaginationComponent={Pagination}
                                        minRows={0}
                                        sortable={false}
                                    />
                                </div>
                            : <div className="no-data-msg"> No rooms Available</div>
                        }
                    </div>
                </div>
                <Modal isOpen={this.state.isDeleteModalOpen} toggle={this.toggleDeleteModal}>
                    <ModalHeader toggle={this.toggleDeleteModal} className="edit-popup delete-title">
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle}/>
                        Delete Room
                    </ModalHeader>
                    <ModalBody className="delete-popup-body delete-popup-body-align">
                        Are you sure you want to delete {this.state.deleteName}
                    </ModalBody>
                    <ModalFooter className="float-sm-right mt-3 bottom-options delete-footer">
                        <Button className="custom-button cancel-button mr-2 delete-room" outline color="secondary" onClick={this.toggleDeleteModal}>No</Button>
                        <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteRoom}>Yes</Button>
                    </ModalFooter>
                </Modal>
                <ToastContainer autoClose={3000} />
                {this.props.isTourOpen ? <Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} /> : null}
                {this.state.addItem === "AddBuilding" ?
                    this.props.history.push("/manage/buildings/addBuildings")
                    :
                    this.state.addItem === "AddFloor" ?
                        this.props.history.push("/manage/buildings/addFloors")
                        : null
                }
            </div>
        )
    }
}

const mapStateToProps = state => {

    return {
        rooms: state.floor_data.rooms,
        roomPagination: state.floor_data.roomPagination,
        roomParams: state.floor_data.roomParams,
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchRooms,
        saveRoom,
        deleteRoom,
    }
)(AddRooms), 'Manage Rooms', 'AddRooms');